import React from 'react';
import { Landmark } from 'lucide-react';

/**
 * Shared PESO referral badge — a branded pill (landmark icon + office name) colored by the
 * office's brand color. Renders nothing when officeName is missing, so callers can drop it in
 * unconditionally: <PesoBadge officeName={x.peso_office_name} color={x.peso_office_color} />.
 *
 * @param {{ officeName?: string, color?: string, className?: string, title?: string }} props
 */
export default function PesoBadge({ officeName, color = '#1d4ed8', className = '', title }) {
  if (!officeName) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold text-white whitespace-nowrap ${className}`}
      style={{ backgroundColor: color }}
      title={title || officeName}
      data-testid="peso-badge"
    >
      <Landmark size={12} className="flex-shrink-0" />
      {officeName}
    </span>
  );
}
